import { AbstractControl, ValidationErrors } from '@angular/forms';

export function asciiOnlyValidator(additionalInvalidChars?: string) {
  return (control: AbstractControl) => asciiOnlyValidatorFunction(control, additionalInvalidChars);
}

function asciiOnlyValidatorFunction(control: AbstractControl, additionalInvalidChars?: string): (ValidationErrors | null) {
  const invalidCharsPattern = additionalInvalidChars
    ? `[^ -~]|[${additionalInvalidChars}]`
    : '[^ -~]';
  const matchedInvalidChars = control.value.match(new RegExp(invalidCharsPattern, 'g'));
  return (matchedInvalidChars && matchedInvalidChars.length > 0)
    ? { nonAsciiPrintable: true }
    : null;
}
